
/** @format */

import React, { type Ref } from 'react'
import { Breadcrumb } from 'antd'

const cx = (...classes: (string | boolean | undefined | null)[]) => classes.filter(Boolean).join(' ')

const StyledBreadcrumb = ({ className, $isLoginPage, style, ...props }: any & { ref?: Ref<any> }) => (
  <Breadcrumb
    className={cx(
      'text-[13px]',
      '[&_.ant-breadcrumb-link.id-segment]:!text-[#999] [&_.ant-breadcrumb-link.id-segment]:!cursor-default [&_.ant-breadcrumb-link.id-segment]:pointer-events-none [&_.ant-breadcrumb-link.id-segment]:font-[JetBrains_Mono,monospace] [&_.ant-breadcrumb-link.id-segment]:bg-[#f5f5f5] [&_.ant-breadcrumb-link.id-segment]:px-1.5 [&_.ant-breadcrumb-link.id-segment]:py-0.5 [&_.ant-breadcrumb-link.id-segment]:rounded [&_.ant-breadcrumb-link.id-segment]:text-xs [&_.ant-breadcrumb-link.id-segment]:font-medium',
      className
    )}
    style={{
      color: $isLoginPage ? 'var(--login-page-header-text)' : '#000',
      ...style,
    }}
    {...props}
  />
)
StyledBreadcrumb.displayName = 'StyledBreadcrumb'

export { StyledBreadcrumb }
